module.exports = "/_next/static/images/pricingPlansConsulting-3f728c21116076f7aeb906049fb55345.webp";